import { initializeDatepickers } from './components/datepicker'
import { initializeFeedback } from './components/feedback'
import { initializeGlossary } from './components/glossary'
import { initializeHomepageQuicklinks } from './components/quicklinks'
import { initializeRelevantPages } from './components/relevantPages'
import { initializeScrollToTop } from './components/scroll'
import { initializeSearchform } from './components/searchform'
import { styleSelectElements } from './components/select'
import { initializeSkipTo } from './components/skipTo'
import { initialiseFourStepSlider } from './components/slider'
import { initializeSortSelect } from './components/sortSelect'
import { initializeSubnavigation } from './components/subnavigation'
import { initializeAccordionTabview } from './components/tabview'
import { initializeFaq } from './components/faq'
import { initializeExternal } from './components/external';

document.addEventListener('DOMContentLoaded', () => {
  initializeScrollToTop('a.return-to-top')
  initializeHomepageQuicklinks('.homepage-quicklinks')
  initialiseFourStepSlider('.fourstep')
  initializeRelevantPages('.relevant-pages')
  styleSelectElements()
  void initializeGlossary('#main')
  initializeAccordionTabview('.tabview.accordion')
  initializeFeedback('.feedback')
  initializeSubnavigation('.menu_item')
  initializeSortSelect()
  initializeDatepickers()
  initializeSearchform()
  initializeSkipTo()
  initializeFaq()
  initializeExternal();
})
